import { useQuery } from '@tanstack/react-query';
import pulseService from '../services/pulseService';

export function usePulseData() {
  return useQuery({
    queryKey: ['pulse', 'latest'],
    queryFn: () => pulseService.getHistory({ type: 'heartbeat', limit: 1 }),
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    retry: 1,
  });
}
